import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";

export class SettingModel extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SettingModel, v) : SKIP;
            },
            (v) => {
                return deserialize(SettingModel, v) || new SettingModel();
            }
        );
    }

    constructor(name = null, value = null) {
        super();

        this._name = name;
        this._value = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;
    }


    valid() {
        return this.name != null && this.name.length > 0;
    }

    empty() {
        return false;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SettingModel());
        } else if (target instanceof SettingModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SettingModel, {
    _uid: alias("uid", Schema.primitive()),
    _enabled: alias("enabled", Schema.primitive()),

    _name: alias("name", Schema.primitive()),
    _value: alias("value", Schema.primitive())
});